import React from "react";

const SuccessAlert = ({ message }) => {
  return (
    <div
      className="mb-3 mt-3 border-l-4 border-emerald-300 bg-emerald-700 p-4 text-sm font-light text-gray-50"
      role="alert"
    >
      <p className="text-lg font-medium">Success</p>
      <p>{message}</p>
    </div>
  );
};

export default SuccessAlert;
